package kz.dentalcrm.app.screens.diagnosis.add.mvi

import kz.dentalcrm.app.core.base.ViewState

data class AddDiagnosisViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data class Error(val error: String) : ScreenState
        data object Idle : ScreenState
        data object Added : ScreenState
        data object Adding : ScreenState
        data object Loading : ScreenState
    }
}
